import React from "react"
import { Container } from "./SideBarTrialBadge.styled"

const SidebarTrialBadge = () => {
  return <Container>Free trial</Container>
}

export default SidebarTrialBadge
